import React, { useState, useEffect } from 'react'
import { Grid } from '@mui/material'
import Box from '@mui/material/Box';
import { FormControl, TextField } from '@mui/material';
import RemoveIcon from "../../../images/remove.png"
import PlusIcon from "../../../images/plus_icon.png"
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import ApiClient from '../../common/ApiClient';

import DeleteDialog from '../DeleteDialog';
import { useParams } from 'react-router-dom';
import styles from "../../ott/OttPlatform/Stream.module.css"
import Loader from '../../common/Loader/Loader';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import AddBoxIcon from '@mui/icons-material/AddBox';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';


import MenuItem from '@mui/material/MenuItem';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import Typography from '@mui/material/Typography';

import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import { GLOBAL_URL } from '../../../API/global';


import { handleKeyDown, validatePdf } from '../../Helper';
import { validateEmail } from "../../Helper"
const BootstrapDialog = styled(Dialog)(({ theme }) => ({

    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));
const PartialDirectorDetails = ({ setFormDataMain, setOttPlatformErrors, errors, formDataMain }) => {
    const [loading, setLoading] = useState(false);
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [alertSeverity, setAlertSeverity] = useState("success");
    const [directorErrors, setDirectorErrors] = useState("")
    const [selectedDirectorFile, setSelectedDirectorFile] = useState(null);
    const [error, setError] = useState('');
    const [maximumLimitReach, setMaximumLimitReach] = useState(true);


    const validateForm = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = 'Enter your name';
        if (!formData.email) {
            newErrors.email = "Enter your email id";
        }
        else if (!formData.email.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i)) {
            newErrors.email = "Email is not valid.";
        }
        if (!formData.mobile) {
            newErrors.mobile = "Enter your mobile number";
        } else {
            if (formData.mobile.length < 10) {
                newErrors.mobile = "Mobile number must be of 10 digits.";
            }
        }

        if (!formData.address) newErrors.address = 'Enter your address';
        if (!formData.indian_nationality) newErrors.indian_nationality = 'Select one option';
        if (!formData.id_proof) newErrors.id_proof = 'Please upload a file';
        setErrorsForm(newErrors);
        return Object.keys(newErrors).length === 0;
    };



    const { id = null } = useParams();
    const { postRequest, getRequest, deleteRequest } = ApiClient();
    const [errorsForm, setErrorsForm] = useState({});
    const [preData, setPreData] = useState([]);
    const [showForm, setShowForm] = useState(true)
    const [formData, setformData] = React.useState({
        name: "",
        email: "",
        landline: "",
        mobile: "",
        fax: "",
        website: "",
        address: "",
        indian_nationality: "",
        indian_natinality: "",
        id_proof: null,
        is_director_partial_id_proof: 0,
    });
    const loadData = async () => {
        const preData = await getRequest(`${formDataMain.id}/ip-director`);
        const data = preData.data;
        if (data.length > 0) {
            setShowForm(false)
            setFormDataMain(prevData => ({
                ...prevData,
                is_broadcasted_added: 1
            }));
            setOttPlatformErrors({
                ...errors,
                is_broadcasted_added: null
            })
            if (data.length >= 5) {
                setMaximumLimitReach(false)
            } else {
                setMaximumLimitReach(true)
            }
        } else {

            setFormDataMain(prevData => ({
                ...prevData,
                is_broadcasted_added: null
            }));
        }
        //  if (data && data.length < 5) setShowAddNewEntry(true)
        setPreData(data);
    }
    useEffect(() => {
        loadData();

    }, []);

    // const validateForm = () => {
    //     const newErrors = {};
    //     if (!formData.name) newErrors.name = 'name is required';

    //     setErrorsForm(newErrors);
    //     return Object.keys(newErrors).length === 0;
    // };
    const handleFormData = (e) => {
        const { name, value } = e.target;
        setformData(prevData => ({
            ...prevData,
            [name]: value

        }));

        if (name === 'email') {
            errors = validatePersonalEmail(value);
        }

        if (name === 'mobile') {

            const phoneNumber = value.replace(/\D/g, '').slice(0, 10);



            if (phoneNumber.length < 10) {
                errors = `Contact number requires ${10 - phoneNumber.length} more digits.`;
            } else if (phoneNumber.length > 10) {
                errors = `Contact number must be exactly 10 digits.`;
            }
        }










        errorsForm[name] = ""
        setErrorsForm(errorsForm);


    };

    const validatePersonalEmail = (email) => {

        if (!validateEmail(email))
            return 'Invalid email format'
        return "";

    };

    const handleFormDataIndian = (e) => {
        const { name, value } = e.target;
        // console.log({ name })
        if (name === "indian_nationality" && (value === 0 || value === "0")) {
            setOpen(true);
            setformData(prevData => ({
                ...prevData,
                indian_nationality: null, // 
            }));
        } else {
            setformData(prevData => ({
                ...prevData,
                indian_nationality: 1,
            }));
        }

        errorsForm[name] = ""
        setErrorsForm(errorsForm);

    }
    const handleReleaseDate = (e) => {

        if (e) {
            const formattedDate = e.format('YYYY-MM-DD');
            setformData(prevData => ({
                ...prevData,
                stream_date_format: dayjs(formattedDate),
                stream_date: (formattedDate),
            }));
        }
        // Clear the error message for release_date
        setErrorsForm(prevErrors => ({
            ...prevErrors,
            stream_date: ""
        }));

    };

    const Addmore = async (e) => {
        setShowForm(true)
    }
    const mini = async (e) => {
        setShowForm(false)
    }

    const submitForm = async (e) => {
        e.preventDefault();


        if (!validateForm()) return;

        setLoading(true)
        try {

            const response = await postRequest(`${formDataMain.id}/ip-director`, formData)

            if (!response.status) {
                throw new Error(`Error: ${response.status} ${response.statusText}`);
            }

            setformData({
                name: "",
                email: "",
                landline: "",
                mobile: "",
                fax: "",
                website: "",
                address: "",
                indian_nationality: "",
                id_proof: null,
                is_director_partial_id_proof: 0,
            });
            loadData();
            setAlertMessage('Data has been submitted successfully!');
            setAlertSeverity('success');
            setAlertOpen(true);
            //  await loadpreData();
            // Clear the file input after submission
            document.getElementById('fileInput').value = '';
            setSelectedDirectorFile(null);
        } catch (error) {
            console.error("Error: ", error);
            // alert('Error submitting form. Please try again later.');
            setAlertMessage('Error submitting form. Please try again later.');
            setAlertSeverity('error');
            setAlertOpen(true);
        } finally {
            setLoading(false); // Set loading to false when the API call finishes
        }
    };

    const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
    const [prepareDelete, setPrepareDelete] = useState(null);
    const [open, setOpen] = React.useState(false);

    const handleDeleteOpen = (value) => {
        setPrepareDelete(value);
        setOpenDeleteConfirm(true);
        setShowForm(true)
    };

    const handleDeleteClose = (e) => {
        e.preventDefault();
        setOpenDeleteConfirm(false);
    };
    const submitDelete = async (e) => {
        e.preventDefault();
        setLoading(true)
        try {
            const response = await deleteRequest(`ip-director/${prepareDelete}`, formData)

            if (!response.status) {
                throw new Error(`Error: ${response.status} ${response.statusText}`);
            }
            loadData();
            // alert('Record deleted successfully!');
            setAlertMessage('Data has been deleted successfully!');
            setAlertSeverity('error');
            setAlertOpen(true);
            //  await loadpreData();
        } catch (error) {
            console.error("Error: ", error);
            // alert('Error submitting form. Please try again later.');
            setAlertMessage('Error submitting form. Please try again later.');
            setAlertSeverity('error');
            setAlertOpen(true);
        } finally {
            setLoading(false); // Set loading to false when the API call finishes
        }
        setOpenDeleteConfirm(false);
    };

    const handleCloseIndian = () => {
        setOpen(false);
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        const errors = { ...error };

        const selectedFile = event.target.files[0];
        const validateState = validatePdf(selectedFile);
        // console.log({ validateState });
        if (!validateState['status']) {

            setErrorsForm({
                id_proof: validateState.message
            })
        } else {
            if (file && file.type === 'application/pdf') {
                setSelectedDirectorFile(file);
                setError('');
                setDirectorErrors({ ...errors, directorFile: '' });

                setformData((prevState) => ({
                    ...prevState,
                    id_proof: file,
                    is_director_partial_id_proof: 1,
                }));

                // console.log("Selected file:", file);
            } else {
                setSelectedDirectorFile(null);
                const newError = 'Please upload a PDF file.';
                setError(newError); // Set the error message
                setDirectorErrors({ ...errors, directorFile: newError }); // Set file-specific error

                setformData((prevState) => ({
                    ...prevState,
                    id_proof: null,
                    is_director_partial_id_proof: 0,
                }));
            }


            setErrorsForm(prevErrors => ({
                ...prevErrors,
                id_proof: ""
            }));
            setErrorsForm({
                id_proof: ''
            })
        };
    }

    const toRoman = (num) => {
        const romanNumerals = [
            ["XL", 40],
            ["X", 10],
            ["IX", 9],
            ["V", 5],
            ["IV", 4],
            ["I", 1]
        ];

        let roman = "";
        for (let [letter, value] of romanNumerals) {
            while (num >= value) {
                roman += letter;
                num -= value;
            }
        }
        return roman;
    };

    return (
        <>
            {loading && <Loader />}
            <TableContainer component={Paper} style={{ marginTop: '10px' }}>
                <Table sx={{ minWidth: 650 }} aria-label="caption table">
                    {
                        preData && preData.length > 0 ? (
                            <TableHead>
                                <TableRow>
                                    <TableCell align='center'>Sr No.</TableCell>
                                    <TableCell align='center'>Name</TableCell>
                                    <TableCell align="center">E-mail</TableCell>
                                    <TableCell align="center">Landline</TableCell>
                                    <TableCell align="center">Mobile</TableCell>
                                    <TableCell align="center">Website</TableCell>
                                    <TableCell align="center">Address</TableCell>
                                    <TableCell align="center">Nationality</TableCell>
                                    <TableCell align="center">Govt id.</TableCell>
                                    <TableCell align="center">
                                        {maximumLimitReach ? (showForm ? (
                                            <Button onClick={mini}><IndeterminateCheckBoxIcon /></Button>
                                        ) : (
                                            <Button onClick={Addmore}><AddBoxIcon /></Button>
                                        )) : <></>}
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                        ) : <></>
                    }
                    <TableBody>
                        {preData.map((row, index) => (
                            <TableRow key={row.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell align="center">({toRoman(index + 1)})</TableCell>
                                <TableCell align="center">{row.name}</TableCell>
                                <TableCell align="center">{row.email}</TableCell>
                                <TableCell align="center">{row.landline}</TableCell>
                                <TableCell align="center">{row.mobile}</TableCell>

                                <TableCell align="center">{row.website}</TableCell>
                                <TableCell align="center">{row.address}</TableCell>
                                <TableCell align="center">{(row.indian_nationality) ? 'Indian' : 'Non Indian'}</TableCell>
                                <TableCell align="center">
                                    <a href={`${GLOBAL_URL}downloadfile/ip/${id}/${row?.documents?.[0]?.file}`}>{row?.documents?.[0]?.name}</a>

                                </TableCell>
                                <TableCell align="center">
                                    <Button value={row.id} onClick={() => handleDeleteOpen(row.id)} variant="outlined" color="error" startIcon={<DeleteIcon style={{ color: '#d32f2f' }} />}>
                                    </Button>
                                    <DeleteDialog open={openDeleteConfirm} handleClose={handleDeleteClose} handleDelete={submitDelete} />
                                </TableCell>
                            </TableRow>
                        ))}
                        {
                            (showForm) ?
                                <TableRow>
                                    <TableCell align="center" colSpan={10}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                                <Box>
                                                    <TextField
                                                        variant="outlined"
                                                        fullWidth
                                                        label='(a) Name'
                                                        // InputProps={{
                                                        //   style: {
                                                        //     border: "1px solid #1c5768",
                                                        //     borderRadius: "5px",
                                                        //   },
                                                        // }}
                                                        className="input_border"
                                                        name="name"
                                                        value={formData.name}
                                                        onChange={handleFormData}
                                                    />
                                                    {errorsForm.name && (
                                                        <p className="error-msg text-danger">{errorsForm.name}</p>
                                                    )}
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                                <Box>
                                                    <TextField
                                                        variant="outlined"
                                                        fullWidth
                                                        label='(b) E-mail'
                                                        type='email'
                                                        // InputProps={{
                                                        //   style: {
                                                        //     border: "1px solid #1c5768",
                                                        //     borderRadius: "5px",
                                                        //   },
                                                        // }}
                                                        className="input_border"
                                                        name="email"
                                                        value={formData.email}
                                                        onChange={handleFormData}
                                                        inputProps={{ maxLength: 156 }}
                                                    />
                                                    {errorsForm.email && (
                                                        <p className="error-msg text-danger">{errorsForm.email}</p>
                                                    )}
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                                <Box>
                                                    <TextField
                                                        variant="outlined"
                                                        type='number'
                                                        fullWidth
                                                        label='(c) Landline (Optional)'
                                                        // InputProps={{
                                                        //   style: {
                                                        //     border: "1px solid #1c5768",
                                                        //     borderRadius: "5px",
                                                        //   },
                                                        // }}
                                                        className="input_border"
                                                        name="landline"
                                                        // value={formData.landline}
                                                        value={formData.landline}
                                                        onChange={handleFormData}
                                                        onKeyDown={handleKeyDown}
                                                        onInput={(e) => {
                                                            if (e.target.value.length > 10) e.target.value = e.target.value.slice(0, 10);
                                                        }}
                                                    />
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                                <Box>
                                                    <TextField
                                                        type='number'
                                                        fullWidth
                                                        label='(d) Mobile'
                                                        inputProps={{ maxLength: 10 }}
                                                        className="input_border"
                                                        name="mobile"
                                                        value={formData.mobile}
                                                        onChange={handleFormData}
                                                        onKeyDown={handleKeyDown}
                                                        onInput={(e) => {
                                                            if (e.target.value.length > 10) e.target.value = e.target.value.slice(0, 10);
                                                        }}
                                                    />
                                                    {errorsForm.mobile && (
                                                        <p className="error-msg text-danger">{errorsForm.mobile}</p>
                                                    )}
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                                <TextField
                                                    fullWidth
                                                    label='(e) Website (Optional)'
                                                    // InputProps={{
                                                    //   style: {
                                                    //     border: "1px solid #1c5768",
                                                    //     borderRadius: "5px",
                                                    //   },
                                                    // }}
                                                    className="input_border"
                                                    name="website"
                                                    type="url"
                                                    // value={formData.website}
                                                    value={formData.website}
                                                    onChange={handleFormData}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                                <Box>
                                                    <Box>
                                                        <TextField
                                                            id="address"
                                                            label="(f) Address"
                                                            multiline
                                                            fullWidth
                                                            // maxRows={5}
                                                            name="address"
                                                            value={formData.address}
                                                            onChange={handleFormData}
                                                        />

                                                    </Box>
                                                    {/* <label for="Address" style={{ fontWeight: "normal" }}>Address</label> */}
                                                    {errorsForm.address && (
                                                        <p className="error-msg text-danger">{errorsForm.address}</p>
                                                    )}
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <div className='ind-nat-rad'>
                                                    <React.Fragment>
                                                        <h6>(i) Indian National<span className='text-danger'>*</span></h6>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="indian_nationality"
                                                                id="indian_natinality_yes"
                                                                value="1"

                                                                checked={formData.indian_nationality == 1}
                                                                onChange={handleFormDataIndian}
                                                            />
                                                            <label className="form-check-label" htmlFor="indian_natinality_yes">
                                                                Yes
                                                            </label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="indian_nationality"
                                                                id="indian_natinality_no"
                                                                value="0"
                                                                checked={formData.indian_nationality === 0 || formData.indian_nationality == "0"}
                                                                onChange={handleFormDataIndian}
                                                            // onClick={handleClickOpen}
                                                            />
                                                            <label className="form-check-label" htmlFor="indian_natinality_no">
                                                                No
                                                            </label>
                                                        </div>
                                                        {errorsForm.indian_nationality && (
                                                            <p className="error-msg text-danger">{errorsForm.indian_nationality}</p>
                                                        )}
                                                        <BootstrapDialog
                                                            onClose={handleCloseIndian}
                                                            aria-labelledby="customized-dialog-title"
                                                            open={open}
                                                        >
                                                            <DialogContent dividers>
                                                                <Typography gutterBottom>
                                                                    Director must be an Indian
                                                                </Typography>
                                                            </DialogContent>
                                                            <DialogActions>
                                                                <Button autoFocus onClick={handleCloseIndian}>
                                                                    Ok
                                                                </Button>
                                                            </DialogActions>
                                                        </BootstrapDialog>

                                                    </React.Fragment>
                                                </div>

                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6} lg={6}>

                                                <h6 className='ind-nat-rad' >(ii) Attach Photo ID issued by the Govt. of India (for Indian National)
                                                    {!(formData?.documentData?.[2]) ? <></> : (
                                                        <div>
                                                            <span className="Attach_Photo_ID">
                                                                <a href={`${GLOBAL_URL}downloadfile/IP/${formData.id}/${formData?.documentData?.[2].file}`}>{formData?.documentData?.[2].name}</a>
                                                            </span>
                                                        </div>
                                                    )}


                                                </h6>


                                                <input
                                                    type="file"
                                                    accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,image/*"
                                                    onChange={handleFileChange}
                                                    style={{ display: 'none', width: "100%" }}
                                                    id="fileInput"
                                                    name="id_proof"
                                                // value={formData.producer_id_proof}
                                                // onChange={handleFormData} 
                                                />
                                                <label htmlFor="fileInput" style={{ width: "100%" }}>
                                                    <TextField
                                                        variant="outlined"
                                                        placeholder="Upload your file in PDF format only"
                                                        value={selectedDirectorFile ? selectedDirectorFile.name : ''}
                                                        InputProps={{
                                                            readOnly: true,
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <IconButton
                                                                        onClick={() => document.getElementById('fileInput').click()}
                                                                        edge="end"
                                                                    >
                                                                        <AttachFileIcon />
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            ),
                                                            style: {
                                                                // border: "1px solid #1c5768",
                                                                borderRadius: "5px",
                                                            },
                                                        }}
                                                        fullWidth
                                                    />
                                                </label>


                                                {errorsForm.id_proof && (
                                                    <p className="error-msg text-danger">{errorsForm.id_proof}</p>
                                                )}
                                            </Grid>


                                            <Grid item xs={3} sm={3} md={3} lg={12}>
                                                <div className='btn-ind'>
                                                    <Button variant="contained" color="success" onClick={submitForm} >
                                                        Save
                                                    </Button>
                                                    {errors.is_broadcasted_added && (
                                                        <p className="text-danger error-handling">{errors.is_broadcasted_added}</p>
                                                    )}
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </TableCell>
                                </TableRow> :
                                <></>
                        }
                    </TableBody>

                </Table>
            </TableContainer>

        </>
    )
}

export default PartialDirectorDetails